import {ATTENDANCE_MODES, MULTIDAYS_MODES} from '../Models/Model';
import React from "react";
import DiningAttendanceDayTable from "./DiningAttendanceDayTable";
import DiningAttendanceTable from "./DiningAttendanceTable";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Software Developer
 * @Email: kpozos@ibl.mx
 *
 * @description
 * This component conditionally renders either `DiningAttendanceTable` or `DiningAttendanceDayTable`
 * based on whether the current `selectedOption` is included in the `MULTIDAYS_MODES` list.
 * It handles the configuration and data management for dining attendance views.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.subView - Current active subview identifier.
 * @param {Function} props.handleBtnDinning - Callback to switch to dining view.
 * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meals view.
 * @param {Array} props.finalArray - Final list of data records.
 * @param {Function} props.setFinalArray - Setter for the final data array.
 * @param {Function} props.setBodyForExport - Setter for the exportable body of data.
 * @param {string} props.searchElement - Current search string value.
 * @param {Function} props.setSearchElement - Setter for search string input.
 * @param {Function} props.setSearch - Function to trigger a search.
 * @param {string} props.simpleSearch - Simple search string input.
 * @param {Function} props.setSimpleSearch - Setter for simpleSearch input.
 * @param {Function} props.cleanAdvance - Function to reset advanced search fields.
 * @param {Object} props.selectedOption - Currently selected option/mode.
 * @param {Function} props.setSelectedOption - Setter for the selected option.
 * @param {JSX.Element|null} props.render - Optional extra element to be rendered (e.g., pagination).
 * @param {Function} props.setRender - Setter for the render content.
 * @param {string} props.color - Color theme or state identifier.
 *
 * @returns {JSX.Element} Rendered dining attendance view based on selected option.
 */
const DiningAttendance = (props) => {
    const {
        subView,
        handleBtnDinning,
        handleBtnSettings,
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        finalArray,
        setFinalArray,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        selectedOption,
        setSelectedOption,
        render,
        setRender,
        color,
        setCriteria,
        modified,
        setModified,
        search
    } = props;

    return (
        <>
            {(selectedOption === ATTENDANCE_MODES.daily || search) && (
                <DiningAttendanceDayTable
                    subView={subView}
                    handleBtnDinning={handleBtnDinning}
                    handleBtnSettings={handleBtnSettings}
                    handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                    handleBtnTotalMeals={handleBtnTotalMeals}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    color={color}
                    modified={modified}
                    setModified={setModified}
                />
            )}

            {!search && MULTIDAYS_MODES.includes(selectedOption) && (
                <DiningAttendanceTable
                    subView={subView}
                    handleBtnDinning={handleBtnDinning}
                    handleBtnSettings={handleBtnSettings}
                    handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                    handleBtnTotalMeals={handleBtnTotalMeals}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    render={render}
                    setRender={setRender}
                    color={color}
                    modified={modified}
                    setModified={setModified}
                />
            )}

        </>
    );
};

export default DiningAttendance;
